const FLAGS = {
  en: 'https://flagcdn.com/48x36/us.png',
  de: 'https://flagcdn.com/48x36/de.png',
  debug: 'https://flagcdn.com/48x36/aq.png',
} as const

export default FLAGS
